import React from 'react';
import styles from './TablesModal.module.scss';

import DialogWrapper from 'components/DialogComponents/DialogWrapper';
import DialogHeader from 'components/DialogComponents/DialogHeader';

import LocationTablesContent from '../LocationTablesContent';

export default function TablesModal({ open, setOpen }) {
  const handleClosePopup = () => setOpen(false);

  return (
    <DialogWrapper open={open} onClose={handleClosePopup}>
      <section className={styles.wrapper}>
        <DialogHeader onClose={handleClosePopup} title="Assets"></DialogHeader>
        <div className={styles.content}>
          <LocationTablesContent />
        </div>
      </section>
    </DialogWrapper>
  );
}
